// UserContext.js
import { createContext, useContext } from 'react';

// Création du contexte utilisateur
const UserContext = createContext();

// Hook pour utiliser le contexte utilisateur
export const useUserContext = () => useContext(UserContext);

export default UserContext;
